<template>
  <footer class="flex jcc" style="background-color: #13104c">
    <div class="header_container flex ai jcs">
      <div class="header_container_left flex jcs">
        <div @click="jumpToExternal('备案')" class="pointer">沪ICP备2025113661号-1</div>
        <!-- <div>沪公网安备 XXXXXXXXXX 号</div> -->
      </div>
      <div class="header_container_right flex jcs">
        <div @click="jumpToExternal('Bayer Global')" class="pointer">Bayer Global</div>
        <div>|</div>
        <div @click="jumpToExternal('Bayer CN')" class="pointer">Bayer CN</div>
        <div>|</div>
        <div @click="jumpToExternal('联系我们')" class="pointer">联系我们</div>
        <div>|</div>
        <div @click="jumpToExternal('使用条款')" class="pointer">使用条款</div>
      </div>
    </div>
  </footer>
  <div v-if="showPopUpJump" class="popup flex ai jcc">
    <div class="popup-content flex column ai">
      <div class="popup-title default">您正在离开One A Day官网页面</div>
      <div class="popup-contentTxt1 default">你已选择进入第三方网站，你将离开拜耳所属的网站并去往第三方独立运营并不被拜耳管理的网络平台。拜耳将不对上述网站的内容及运营承担任何责任。</div>
      <div class="popup-contentTxt2 default">点击“取消”返回当前One A Day网页，点击“继续”访问第三方网站。</div>
      <div class="btnBox flex jcs">
        <div @click="jumpExternal" class="btnContinue flex ai jcc pointer">继续</div>
        <div @click="showPopUpJump = false" class="btnCancel flex ai jcc pointer">取消</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
// 是否展示跳转弹窗
const showPopUpJump = ref(false);
// 跳转名称
const jumpName = ref("");
// 跳转外部网站
const jumpToExternal = (name) => {
  if (name == "Bayer Global") {
    window.open("https://www.bayer.com/en/", "_blank");
  } else if (name == "Bayer CN") {
    window.open("https://www.bayer.com.cn/zh-hans/", "_blank");
  } else if (name == "联系我们") {
    router.push({ name: "contactUs" });
  } else if (name == "使用条款") {
    router.push({ name: "termsOfUse" });
  } else {
    showPopUpJump.value = true;
    jumpName.value = name;
  }
};
const jumpExternal = () => {
  if (jumpName.value == "备案") {
    window.open("https://beian.miit.gov.cn", "_blank");
    showPopUpJump.value = false;
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.popup-content {
  padding: 0.62rem 0.4rem 0.5rem 0.4rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.1rem;
}
.popup-title {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.38rem;
  color: #13104c;
  text-align: center;
}
.popup-contentTxt1 {
  margin-top: 0.26rem;
  width: 6.45rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #13104c;
  line-height: 0.32rem;
}
.popup-contentTxt2 {
  margin-top: 0.16rem;
  width: 6.45rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #13104c;
}
.btnContinue {
  width: 1.31rem;
  height: 0.5rem;
  border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
  border: 0.01rem solid #13104c;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.3rem;
  color: #000000;
}
.btnCancel {
  width: 1.31rem;
  height: 0.5rem;
  background: #13104c;
  border-radius: 0.03rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.3rem;
  color: #ffffff;
}
.btnBox {
  margin-top: 0.46rem;
  width: 3.67rem;
}
.header_container {
  width: 13.71rem;
  height: 125px;
  background: #13104c;
  box-sizing: border-box;
}
.header_container_left {
  width: 5.49rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #ffffff;
}
.header_container_right {
  width: 5.27rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #ffffff;
}
</style>
